
import Base from './Base';

class FormController extends Base {

}

export default FormController;
